<template>
  <div class="editor-slider" v-on:mousedown="onMouseDown($event, {preventDefault: true})" v-on:touchstart.passive="onMouseDown($event)">
    <div class="bar"></div>
    <div class="filler" v-bind:style="{
      right: (valuePercent < 50 ? 50 : 100-valuePercent) + '%',
      left: (valuePercent < 50 ? valuePercent : 50) + '%',
    }"></div>
    <div class="knob" v-bind:style="{left: valuePercent + '%'}">
      <i class="fal fa-hand-pointer"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initialValue: Number,
    minValue: Number,
    maxValue: Number,
  },
  data: function() {
    return {
      value: this.initialValue,
      isMouseDown: false,
    }
  },
  methods: {
    onMouseDown: function(e, opts = {}) {
      if(opts.preventDefault) {
        // prevent drag
        if(e.preventDefault) {
          e.preventDefault()
        }
        else {
          e.returnValue = false;
        }
      }
      if(!this.isMouseDown) this.startDragging();
      this.updateValue(e);
    },
    onMouseUp: function(e) {
      if(this.isMouseDown) this.stopDragging();
    },
    onMouseMove: function(e) {
      if(!this.isMouseDown) return;
      this.updateValue(e);
    },
    updateValue: function(e) {
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      var rect = this.$el.getBoundingClientRect();
      this.value = Math.round(((clientX - rect.left) / (rect.right - rect.left)) * (this.maxValue - this.minValue) + this.minValue);
      if(this.value > this.maxValue) this.value = this.maxValue;
      if(this.value < this.minValue) this.value = this.minValue;
      this.$emit('change', { newValue: this.value });
    },
    startDragging: function()  {
      this.isMouseDown = true;
      window.addEventListener('mouseup', this.onMouseUp);
      window.addEventListener('touchend', this.onMouseUp);
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('touchmove', this.onMouseMove, {passive: true});
      this.$emit("drag");
    },
    stopDragging: function() {
      this.isMouseDown = false;
      window.removeEventListener('mouseup', this.onMouseUp);
      window.removeEventListener('touchend', this.onMouseUp);
      window.removeEventListener('mousemove', this.onMouseMove);
      window.removeEventListener('touchmove', this.onMouseMove);
      this.$emit("drop");
    }
  },
  unmounted: function() {
      // remove any remaining listeners
    this.stopDragging();
  },
  computed: {
    valuePercent: function() {
      return 100 * (this.value - this.minValue) / (this.maxValue - this.minValue);
    }
  }
}
</script>

<style scoped>
  .editor-slider {
    cursor: pointer;
    position: relative;
    height: 30px;
  }
  .bar {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    margin-top: -4px;
    z-index: 30;

    border: 1px solid #fff;
    height: 8px;
    border-radius: 4px;
  }
  .filler {
    position: absolute;
    top: 50%;
    margin-top: -4px;
    z-index: 50;

    border: 1px solid #fff;
    height: 8px;
    border-radius: 4px;
    background: #8d8d8d;
  }
  .knob {
    position: absolute;
    top: 0;
    z-index: 100;
    color: #fc1b44;
    font-size: 30px;
    line-height: 1;

    height: 30px;
    width: 30px;
    margin-left: -15px;
    border-radius: 15px;
    background: #fff;
    text-align: center;
  }
  @media(min-width: 768px) {
    .bar, .filler {
      border-color: #585858;
    }
    .knob {
      background: #585858;
    }
  }
</style>
